import React from 'react';

interface TooltipProps {
  children: React.ReactNode;
  label: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = React.memo(({
  children,
  label,
  position = 'top',
  className = '',
}) => {
  const posClasses: Record<string, string> = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-1.5',
    left: 'right-full top-1/2 -translate-y-1/2 mr-1.5',
    right: 'left-full top-1/2 -translate-y-1/2 ml-1.5',
  };

  return (
    <span className={`group/tooltip relative inline-flex ${className}`}>
      {children}
      <span
        className={`
          ${posClasses[position]}
          pointer-events-none absolute z-50 whitespace-nowrap rounded-md
          bg-slate-900 px-2 py-1 text-xs text-slate-50 shadow-lg
          opacity-0 transition-opacity duration-150
          group-hover/tooltip:opacity-100
        `}
        role="tooltip"
      >
        {label}
        <span
          className={`absolute block h-1.5 w-1.5 rotate-45 bg-slate-900 ${
            position === 'top'
              ? 'left-1/2 top-full -translate-x-1/2 -translate-y-1/2'
              : position === 'bottom'
              ? 'left-1/2 bottom-full -translate-x-1/2 translate-y-1/2'
              : position === 'left'
              ? 'left-full top-1/2 -translate-y-1/2 -translate-x-1/2'
              : 'right-full top-1/2 -translate-y-1/2 translate-x-1/2'
          }`}
        />
      </span>
    </span>
  );
});

export default Tooltip;
